import { useLazyQuery } from '@apollo/client/react';
import { MeDocument } from '@graphql/types';
import { useCallback } from 'react';

import type { MeResponse } from '../types';

export const useMeQuery = () => {
  const [meQuery, { loading: meLoading }] = useLazyQuery(MeDocument);

  const doMeQuery = useCallback(async (): Promise<MeResponse> => {
    const response = await meQuery();
    const res = response.data?.me;

    return res as MeResponse;
  }, [meQuery]);

  return { doMeQuery, meLoading };
};
